"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "malgesso": {
    "e9aca695": [{
      "hkey": "02e09703",
      "slug": "bardello-con-malgesso-e-bregano",
      "name": "Bardello con Malgesso e Bregano",
      "primary": true,
      "skipSearch": false
    }],
    "malgesso": [{
      "hkey": "02e09703",
      "slug": "bardello-con-malgesso-e-bregano",
      "name": "Bardello con Malgesso e Bregano",
      "primary": true,
      "levelFrom": 9,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1beb0fe3": [{
      "hkey": "5eedce70",
      "slug": "costanza",
      "name": "Costanza",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-costanza": [{
      "hkey": "5eedce70",
      "slug": "costanza",
      "name": "Costanza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "149cfb6c": [{
      "hkey": "eb40bd62",
      "slug": "malgesso",
      "name": "Malgesso",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "eb40bd62",
      "slug": "malgesso",
      "name": "Malgesso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;